import React, { Component } from "react";
import { convertDateFormat } from "../../utils/helperFunctions";

import { MDBBtn, MDBDataTable } from "mdbreact";
import { Row, Col } from "reactstrap";
import Pagination from "../Common/Pagination";
import { translate } from "react-i18next";

class ReportTable extends Component {
  state = {
    loadTable: false,
    pagination: {},
  };

  columns = [
    {
      label: this.props.t("dashboard.reportName"),
      field: "name",
      sort: "asc",
      width: 250,
    },
    {
      label: this.props.t("dashboard.temperature"),
      field: "temp",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.humidity"),
      field: "humidity",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.carbon"),
      field: "carbon",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.pressure"),
      field: "pressure",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.report"),
      field: "enable",
      sort: "asc",
      width: 150,
    },
    {
      label: this.props.t("dashboard.createdAt"),
      field: "createdAt",
      sort: "asc",
      width: 250,
    },
    {
      label: this.props.t("dashboard.action"),
      field: "action",
      width: 80,
    },
  ];

  componentDidMount() {
    const { reports } = this.props;
    if (reports && reports.length) {
      this.showTable(true);
    } else {
      this.showTable(false);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.reports !== this.props.reports &&
      this.props.reports &&
      this.props.reports.length
    ) {
      this.showTable(true);
    }
  }

  showTable = (loadTable) => {
    if (loadTable) {
      const { reports, editReport, deleteReport, pagination, t } = this.props;
      const component = this;
      const rows = reports.map((report, index) => {
        let reportRow = { ...report };
        reportRow.temp =
          reportRow.temp === 1
            ? t("dashboard.enabled")
            : t("dashboard.disabled");
        reportRow.humidity =
          reportRow.humidity === 1
            ? t("dashboard.enabled")
            : t("dashboard.disabled");
        reportRow.carbon =
          reportRow.carbon === 1
            ? t("dashboard.enabled")
            : t("dashboard.disabled");
        reportRow.enable =
          reportRow.enable === 1
            ? t("dashboard.enabled")
            : t("dashboard.disabled");
        reportRow.pressure =
          reportRow.pressure === 1
            ? t("dashboard.enabled")
            : t("dashboard.disabled");
        reportRow.createdAt = convertDateFormat(
          reportRow.createdAt,
          "shortDateTime"
        );
        reportRow.action = (
          <>
            <MDBBtn
              onClick={deleteReport.bind(component, reportRow.id)}
              tag="a"
              rounded
              size="sm"
              className="px-2 transparentBtn"
            >
              <i className="fas fa-trash mt-0"></i>
            </MDBBtn>
            <MDBBtn
              onClick={editReport.bind(this, reportRow)}
              tag="a"
              rounded
              size="sm"
              className="px-2 transparentBtn"
            >
              <i className=" fas fa-pencil-alt mt-0"></i>
            </MDBBtn>
          </>
        );
        return reportRow;
      });
      this.setState({
        loadTable,
        reportList: {
          columns: this.columns,
          rows: rows,
        },
        pagination,
      });
    } else {
      this.setState({ loadTable });
    }
  };

  render() {
    const { changePage, t } = this.props;
    const { loadTable, reportList, pagination } = this.state;

    return (
      <React.Fragment>
        {loadTable ? (
          <div>
            <MDBDataTable
              className="hideLastColSort recentAlarmTable border-0"
              bordered
              data={reportList}
              paging={false}
              scrollX
              searchLabel={t("dashboard.search")}
            />
            <Row className="mt-3 mb-3">
              <Col lg={6}>
                <label className="ml-3">
                  {t("dashboard.showing")} {pagination.currentPage * 10 - 9}{" "}
                  {t("dashboard.to")} {pagination.currentPage * 10}{" "}
                  {t("dashboard.of")} {t("dashboard.result")}
                </label>
              </Col>
              <Col lg={6} className="text-right">
                <Pagination
                  pagination={pagination}
                  changePage={(page) => changePage(page)}
                ></Pagination>
              </Col>
            </Row>
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

export default translate("translations")(ReportTable);
